<template>
  <div class="listDetailsWrapper">
    <slot name="content"></slot>
  </div>
</template>

<script setup lang="ts">
  defineProps({
    caller: null,
  })
</script>

<style scoped>
  @import '../../index.less';
</style>
